/**
 * Creates a dashed line marker for tooltip display.
 * Used for type well markLine series (horizontal lines) on box plots.
 */
const getSeriesTooltipDashedLine = (color: string): string => {
  const newColor = color || "black";

  // Dashed line using border-top with dashed style
  return `<span style="display:inline-block;margin-right:5px;width:16px;height:0;border-top:2px dashed ${newColor};vertical-align:middle"></span>`;
};

export default getSeriesTooltipDashedLine;
